export default __webpack_public_path__ + "static/red-298e7b3edd977a64460578e6df959e72.mp3";